<template>
    <div class="register-container" v-show="show">
        <div class="form-box">
            <p class="title">
                注册账号
            </p>
            <el-form>
                <el-form-item>
                    <el-input auto-complete="off" placeholder="请输入手机号" v-model="info.account"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input auto-complete="off" placeholder="请输入邮箱" v-model="info.email"></el-input>
                </el-form-item> -->
                <!-- <el-form-item>
                    <el-input auto-complete="off" placeholder="请输入真实姓名" v-model="info.real_name"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-input auto-complete="off"  type="password" placeholder="请输入密码" v-model="info.passport"></el-input>
                </el-form-item>
                <el-form-item class="verification-code">
                    <el-input auto-complete="off"   placeholder="验证码" v-model="info.captcha"></el-input>
                    <el-button @click="sendCaptcha" v-loading="sendCaptchaLoading" :disabled="captchaBtnDisabled">{{captchaBtnText}}</el-button>
                </el-form-item>
                
                <el-form-item prop="origin">
                    <el-select v-model="info.origin" placeholder="通过哪个渠道得知GBC">
                        <el-option
                        v-for="item in origins"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="info.origin === '其他'">
                    <el-input auto-complete="off" placeholder="请输入渠道" v-model="other"></el-input>
                </el-form-item>
                <el-form-item class="register">
                    <el-button @click="sub">立即注册</el-button>
                </el-form-item>
            </el-form>
            <div class="bottom-box">
                <span>已有账号？</span>
                <router-link to="login">点击登录</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import {
    apiSendSmsCaptcha,
    apiRegister,
    apiSSORegister
} from '../../plugins/apis'
import "../../assets/css/register.css";
export default {
    data(){
        return {
            other:'',
            info:{
                account:'',
                passport:'',
                real_name:'',
                captcha:'',
                origin:'',
            },
            origins:[
                {
                    value:'高校方向班',
                    label:'高校方向班'
                },
                // {
                //     value:'智联招聘',
                //     label:'智联招聘'
                // },
                {
                    value:'官网及官微',
                    label:'官网及官微'
                },
                {
                    value:'网络',
                    label:'网络'
                },
                {
                    value:'其他',
                    label:'其他'
                },
                
                                
            ],
            sendCaptchaLoading:false,
            captchaBtnDisabled:false,
            captchaBtnText:'发送验证码',
            second:60,
            show:false
        }
    },
    mounted() {
        this.toSSO()
    },
    methods:{
        async toSSO(){
            var _data = {
                redirect_uri:'https://gbc.cncima.com/report/login'
            }
            let e = await apiSSORegister(_data)
            if(e.code == 200){
                window.location.href=e.data
            }
        },
        async sub (){
            this.info.origin = this.other
            let _data = this.info
            let res = await apiRegister(_data)
            if(res.code === 200){
                this.$message.success('注册成功，正在跳转...')
                console.log(res.data);
                setTimeout(()=>{
                    window.localStorage.setItem('app_token',res.data.token)
                    this.$router.push('/form')
                },1500)
            }else{
                this.$message.error(res.message)
            }
        },
        async sendCaptcha(){
            if(!this.info.account){
                this.$message.error("请输入账号")
                return
            }
            this.sendCaptchaLoading =  true
            let res = await apiSendSmsCaptcha('register',this.info.account)
            if(res.code === 200){
                this.$message.success('发送成功')
                this.sendCaptchaLoading = false
                this.rushCaptchaBtn()
            }else{
                this.sendCaptchaLoading = false
                this.$message.error(res.message)
            }

            this.sendCaptchaLoading = false
        },
        rushCaptchaBtn(){
            if(this.second === 0){
                this.captchaBtnDisabled = false
                this.second = 60
                this.captchaBtnText = '发送验证码'
            }else{
                --this.second
                this.captchaBtnText = this.second + '秒后重试'
                this.captchaBtnDisabled = true
                setTimeout(()=>{
                    this.rushCaptchaBtn()
                },1000) 
            }
        }
    }
}
</script>

<style>

</style>

